// extracted by mini-css-extract-plugin
module.exports = {"layout":"Collapsible_layout__aHUyL"};